import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { persistGraftcodeOnboardingState } from '../graftcode-onboarding.persistence'

import { createGraftcodeOnboardingActions } from './graftcode-onboarding.actions'
import { graftcodeOnboardingInitialState } from './graftcode-onboarding.slice'
import type { GraftcodeOnboardingStore } from './graftcode-onboarding.type'

const persistIfNeeded = (state: GraftcodeOnboardingStore) => {
  if (!state.hydrated) {
    return
  }
  persistGraftcodeOnboardingState(state)
}

export const useGraftcodeOnboardingStore = create<GraftcodeOnboardingStore>()(
  devtools(
    (set, get) => {
      const setAndPersist: Parameters<typeof createGraftcodeOnboardingActions>[2] = (partial, actionName) => {
        set(partial, false, actionName)
        persistIfNeeded(get())
      }

      return {
        ...graftcodeOnboardingInitialState,
        ...createGraftcodeOnboardingActions(set, get, setAndPersist),
      }
    },
    {
      name: StoreDevtoolsName.GraftcodeOnboarding,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
